import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import {
  AddFunnelResponseV2,
  AddLeadTypeDefaultUserResponseV2,
  GetFunnelResponseV2,
  GetUsersByLeadTypeResponseDataV2,
  LeadTypesDefaultUsersV2,
  UpdateLeadTypeDTO,
  UpdateLeadTypeReferralConfigurationDTO,
  UpdateLeadTypeResponseV2,
} from "@/modules/funnels/dtos/index.v2";
import { UUID } from "crypto";

export const addFunnelV2 = async (data: any, organizationUId: string) => {
  const apiUrl = brandUrl<AddFunnelResponseV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/funnels`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      data: {
        ...data,
        organizationUId: organizationUId,
      },
      includeSingleOrganization: true,
    },
  }) as Promise<AddFunnelResponseV2>;
};

export const updateFunnelV2 = async (
  funnelId: string,
  data: any,
  organizationUId: string
) => {
  const apiUrl = brandUrl<AddFunnelResponseV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/funnels/${funnelId}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
      data: {
        ...data,
        organizationUId: organizationUId,
      },
    },
  }) as Promise<AddFunnelResponseV2>;
};

export const getLeadTypesDefaultUsersByIdV2 = async (leadTypeUId: string) => {
  const apiUrl = brandUrl<LeadTypesDefaultUsersV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/${leadTypeUId}/lead-type-default-users`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<{ data: LeadTypesDefaultUsersV2[] }>;
};

export const getUsersByLeadTypeUId = async (leadTypeUId: string) => {
  const apiUrl = brandUrl<GetUsersByLeadTypeResponseDataV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-types/${leadTypeUId}/users`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<GetUsersByLeadTypeResponseDataV2>;
};

export const deleteLeadTypeDefaultUserV2 = async (userLeadTypeId: UUID) => {
  const apiUrl = brandUrl<{ deleted: boolean }>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-type-default-users/${userLeadTypeId}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.DELETE,
    },
  }) as Promise<{ deleted: boolean }>;
};

export const updateLeadTypeV2 = async (
  leadTypeId: string,
  data: UpdateLeadTypeDTO
) => {
  const apiUrl = brandUrl<UpdateLeadTypeResponseV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-types/${leadTypeId}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
      data: {
        ...data,
      },
    },
  }) as Promise<UpdateLeadTypeResponseV2>;
};

export const addLeadTypeDefaultUserV2 = async (
  userId: string,
  leadTypeId: string
) => {
  const apiUrl = brandUrl<AddLeadTypeDefaultUserResponseV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/${leadTypeId}/lead-type-default-users`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      data: {
        userUId: userId,
      },
    },
  }) as Promise<AddLeadTypeDefaultUserResponseV2>;
};

export const getStatusFunnelsV2 = async (params: any) => {
  const apiUrl = brandUrl<GetFunnelResponseV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/funnels`
  );
  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: {
        ...params,
      },
      includeSingleOrganization: true,
    },
  }) as Promise<GetFunnelResponseV2>;
};

export const updateLeadTypeReferralConfigurationsV2 = async (
  leadTypeId: string,
  data: UpdateLeadTypeReferralConfigurationDTO
) => {
  const apiUrl = brandUrl<UpdateLeadTypeResponseV2>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/lead-types/${leadTypeId}/referral-configuration`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
      data: {
        ...data,
      },
    },
  }) as Promise<UpdateLeadTypeResponseV2>;
};
